import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import preventDefaultPropagation from 'client/helpers/preventDefaultPropagation';
import isFrontConversationNotAnswered from 'common/util/isFrontConversationNotAnswered';

import SrFrontConversationModal from 'client/components/SrFrontConversationModal';

class SrFrontConversation extends Component {
  static propTypes = {
    frontConversation: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    text: PropTypes.string,
    ctaClassName: PropTypes.string,
  }

  static defaultProps = {
    text: 'Messages',
  }

  constructor() {
    super();

    this.state = {
      showFrontConversation: false,
    };
  }

  _toggleFrontConversation = () => {
    this.setState({ showFrontConversation: !this.state.showFrontConversation });
  }

  render() {
    const {
      showFrontConversation,
    } = this.state;

    const {
      frontConversation,
      text,
      ctaClassName,
    } = this.props;

    return (
      <div
        className={classnames('SrFrontConversation', {
          warning: (
            isFrontConversationNotAnswered(frontConversation)
          ),
        })}
        onClick={preventDefaultPropagation}
      >
        <span
          className={classnames('linkOut chat', ctaClassName)}
          onClick={this._toggleFrontConversation}
        >
          {text}
        </span>

        {showFrontConversation && (
          <SrFrontConversationModal
            frontConversation={frontConversation}
            user={this.props.user}
            dispatch={this.props.dispatch}
            onClose={this._toggleFrontConversation}
          />
        )}
      </div>
    );
  }
}

SrFrontConversation.displayName = 'SrFrontConversation';

export default SrFrontConversation;
